import { request } from '../../api'
import { useServerFetch } from '../../composables/useServerFetch'
import type { WebHomeExchangeRankingItem } from '../home'

export interface baseResponse<T> {
  code: number
  message: string
  succeed: boolean
  data: T
}

export type SearchDefaultDiscoverItem = {
  code?: string
  icon?: string
  name?: string
}

export type SearchDefaultGlobalRankItem = {
  code?: string
  icon?: string
  name?: string
  score?: string
}

export type SearchDefaultResponse = {
  discoverList?: SearchDefaultDiscoverItem[]
  globalRank?: SearchDefaultGlobalRankItem[]
}

export type SearchSuggestItem = {
  alias: any
  businessOperations: any
  annotation?: string
  brandCode?: string
  code?: string
  color?: string
  flag?: string
  hico?: string
  icon?: string
  logo?: string
  platform?: number
  score?: number
  showName?: string
  sortedLabel?: {
    labelType: number
    content: string
    borderColor: string
    backgroundColor: string
    fontColor: string
    image: string
  }[]
  textScore?: string
  businessTypes?: {
    businessType: number
    businessTypeName: string
    screenshots?: string | null
  }[]
}

export type SearchResultResponse =
  | SearchSuggestItem[]
  | {
      list?: SearchSuggestItem[]
    }

export type BlackPlatformRankingResponse =
  | WebHomeExchangeRankingItem[]
  | {
      list?: WebHomeExchangeRankingItem[]
    }

export const getSearchDefault = () => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/search/default',
    method: 'GET',
  }

  return import.meta.server
    ? useServerFetch<baseResponse<SearchDefaultResponse>>(requestConfig)
    : request<baseResponse<SearchDefaultResponse>>(requestConfig)
}

export const getSearchSuggest = (keyword: string, size = 8) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/search/suggest',
    method: 'GET',
    params: {
      keyword,
      size,
    },
  }

  return import.meta.server
    ? useServerFetch<SearchResultResponse>(requestConfig)
    : request<SearchResultResponse>(requestConfig)
}

export const getSearch = (keyword: string, size = 8, page = 1) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/search/results',
    method: 'GET',
    params: {
      keyword,
      size,
      page,
    },
  }

  return import.meta.server
    ? useServerFetch<SearchSuggestItem[]>(requestConfig)
    : request<SearchSuggestItem[]>(requestConfig)
}

export const getBlackPlatformRanking = (pageSize = 8, page = 1) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/rank/black-platform',
    method: 'GET',
    params: {
      page,
      pageSize,
    },
  }

  return import.meta.server
    ? useServerFetch<BlackPlatformRankingResponse>(requestConfig)
    : request<BlackPlatformRankingResponse>(requestConfig)
}
